import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { PageChromeProvider } from '@/shared/contexts/PageChromeContext';
import { ErrorBoundary } from '../feedback/ErrorBoundary';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import type { SidebarProps } from './Sidebar';

/** Native DOM owns layout: Gluestack v1's RN primitives discard className. */
export function AppLayout({ renderProjects, navItems }: SidebarProps = {}): React.JSX.Element {
  const { pathname } = useLocation();
  const mainRef = useRef<HTMLElement>(null);
  useEffect(() => {
    // `.app-shell__main` is the scroll container on desktop (≥901px); the document itself
    // is the fallback on a narrower viewport, where the shell isn't height-bound.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    mainRef.current?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);
  return (
    <PageChromeProvider>
      <div className="app-shell">
        <Sidebar renderProjects={renderProjects} navItems={navItems} />
        <div className="app-shell__content">
          <Header />
          <main ref={mainRef} className="app-shell__main" id="main-content">
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </main>
        </div>
      </div>
    </PageChromeProvider>
  );
}
